import React from 'react';

export type PresetButtonItem = {
  label: string;
  value: string;
};

type PresetButtonsProps = {
  buttons: PresetButtonItem[];
  selectedButton: PresetButtonItem;
  onSelect: (button: PresetButtonItem) => void;
};

export const PresetButtons: ({
  buttons,
  selectedButton,
  onSelect,
}: PresetButtonsProps) => JSX.Element = ({
  buttons,
  selectedButton,
  onSelect,
}) => {
  return (
    <div className='border-solid border-customBlue border-2 p-1 rounded-lg flex gap-3 w-max'>
      {buttons.map((button) => {
        const isSelectedButton = selectedButton.value === button.value;

        return (
          <button
            key={button.value}
            className={`${isSelectedButton ? 'btn-small' : 'btn-transparent'} rounded-lg h-14`}
            type='button'
            onClick={() => {
              if (isSelectedButton) return;
              onSelect(button);
            }}
          >
            {button.label}
          </button>
        );
      })}
    </div>
  );
};
